import React, { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { Chip, CHIP_TYPES, Icon } from '@st-operations/uikit/src/v2/index'

const AttributeChip = ({ attribute, onRemoveAttribute, index, id, moveChip, isSnapshot }) => {
  const ref = useRef(null)
  const [{ handlerId }, drop] = useDrop({
    accept: 'column',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveChip(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
  })

  const [{ isDragging }, drag] = useDrag({
    type: 'column',
    item: () => {
      return { id, index }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const opacity = isDragging ? 0.5 : 1
  const cursor = isDragging ? 'grabbing' : 'grab'

  drag(drop(ref))

  return (
    <div draggable ref={ref} data-handler-id={handlerId} style={{ opacity, cursor }}>
      <Chip
        small
        className="attribute-configuration__chip"
        value={
          <div className="attribute-configuration__chip-content">
            <Icon type="outline" icon="drag" color="currentColor" width={16} height={16} />
            <div>{attribute}</div>
          </div>
        }
        onClick={onRemoveAttribute(index)}
        type={CHIP_TYPES.OUTLINED}
        style={isSnapshot ? { display: 'none' } : undefined}
      />
    </div>
  )
}

export default AttributeChip
